// extracted by mini-css-extract-plugin
module.exports = {"subtitleWrapper":"customersListItem_subtitleWrapper__2eYIh","subtitle":"customersListItem_subtitle__uPPsj","title":"customersListItem_title__2jfM9"};